module.exports = __webpack_public_path__ + "static/media/iris_cropped_3.6c43586d.png";